export interface UserProfile {
  firstName: string;
  lastName: string;
  email: string;
  fullName: string;
}

export interface AuthConfig {
  oktaAuth: any;
  onAuthRequired?: (oktaAuth: any) => void;
}

export interface AuthState {
  isAuthenticated: boolean;
  user: UserProfile | null;
  loading: boolean;
  error: string | null;
}
